module.exports = "https://www.gc-pro.gnp.com.mx/9a0482abd24fa73da9045a878a7c902e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/code-icon.png
// module id = 1810
// module chunks = 0